import React, {useState} from 'react';
import { GrAdd } from "react-icons/gr";
import { GrSubtract } from "react-icons/gr";
import ProjectArchive from '../pages/ProjectArchive';
const ProjectArchiveLink = () => {
  const[isVisible, setIsVisible]= useState(false);
  const handleClick=()=>{
    setIsVisible(!isVisible)
  }
  return (
    <>
      {/* <Link to="/ProjectArchive" className='flex resume items-center hover:text-violet-300 focus-visible:text-violet-300'><h3>View Full Project Archive</h3> <EnternalLink className="color:text-violet-300" /></Link>

      <Routes>
        <Route path="/ProjectArchive" element={<ProjectArchive />} />
      </Routes> */}

      <button onClick={handleClick} className=' project-archive-link '> <h3 className='flex gap-2 items-center  hover:text-violet-300 focus-visible:text-violet-300'>View Full Project Archive {isVisible ?  <GrSubtract /> : <GrAdd />}</h3></button>

      {isVisible && <ProjectArchive />}
    </>
  );
};

export default ProjectArchiveLink;